/*@ngInject*/
const ComponentSettingsUtil = function (componentSettingsConstant) {

    this.getOptionGroup = function (settingName) {
        // These option groups are not defined on the server, so we hard code them here. If in the future
        // they are added server-side, it wouldn't be difficult to change this.
        // UMS-19602
        switch (settingName) {
            case 'variableName':
            case 'flags':
            case 'syncToProperty':
                return componentSettingsConstant.optionGroups.CORE_SETTINGS;

            case 'displayLabel':
            case 'labelFontStyle':
            case 'labelPosition':
            case 'tooltipText':
            case 'labelWidth':
            case 'width':
            case 'spacerWidth':
                return componentSettingsConstant.optionGroups.DISPLAY_SETTINGS;

            case 'agencyVisible':
            case 'carrierVisible':
            case 'conditional':
            case 'showForProducts':
            case 'showRule':
                return componentSettingsConstant.optionGroups.VISIBILITY_SETTINGS;

            case 'agencyEditableFieldLevel':
            case 'carrierEditableFieldLevel':
            case 'disableExpressions':
                return componentSettingsConstant.optionGroups.EDITABILITY_SETTINGS;

            case 'requiredFieldLevel':
            case 'requiredLevelExpression':
                return componentSettingsConstant.optionGroups.REQUIRED_SETTINGS;

            case 'validator':
            case 'editRegularExpression':
            case 'numberDomain':
            case 'allowNegative':
            case 'addPercent':
            case 'minimumValueForRangeValidation':
            case 'maximumValueForRangeValidation':
            case 'addRounding':
            case 'addDollarSign':
            case 'dataSetType':
            case 'dataSetNames':
            case 'otherValidator':
            case 'maxChars':
                return componentSettingsConstant.optionGroups.VALIDATION_SETTINGS;

            case 'textDefaultValue':
            case 'checkboxDefaultValue':
            case 'yesNoDefaultValue':
            case 'valueExpression':
            case 'linkTo':
            case 'linkRefreshable':
            case 'dynamicDataSetDefault':
            case 'dataSetDefaultValue':
            case 'dataSetTextDefaultValue':
            case 'multiSelectDataSetDefaultValue':
            case 'multiSelectDataSetTextDefaultValue':
                return componentSettingsConstant.optionGroups.VALUE_SETTINGS;

            case 'prompt':
            case 'height':
            case 'spacerHeight':
            case 'logAccess':
            case 'parameters':
            case 'functionClass':
            case 'attachmentType':
            case 'isDropTargetChecked':
            case 'dropTargetHeight':
            case 'dropTargetPrompt':
            case 'isImageDisplayChecked':
            case 'imageHeight':
            case 'imageWidth':
            case 'showRowNumber':
            case 'rowsPerPage':
            case 'showAddButton':
            case 'showDeleteButton':
            case 'showImportButton':
            case 'showExportButton':
            case 'exportParameters':
            case 'maxRowsToDisplay':
            case 'formRepeaterSummary':
            case 'showYesText':
            case 'showNoText':
            case 'yesText':
            case 'noText':
            case 'enableTimeEntry':
            case 'classCodeType':
            case 'classCodeLabel':
            case 'maxWidth':
            case 'minWidth':
            case 'confirmationTitle':
            case 'confirmationMessage':
            case 'yesButtonLabel':
            case 'noButtonLabel':
            case 'processingIndicatorText':
            case 'dropDownOtherTrigger':
            case 'textOtherTrigger':
            case 'otherPrompt':
            case 'summaryColumns':
            case 'rowRepeaterRequired':
            case 'encryptedValue':
            case 'dropdownExecutor':
            case 'dropdownExecutorPrompt':
            case 'dropdownExecutorParameters':
            case 'dropdownExecutorConfirmationTitle':
            case 'dropdownExecutorConfirmationMessage':
            case 'dropdownExecutorYesButtonLabel':
            case 'dropdownExecutorNoButtonLabel':
            case 'dropdownExecutorProcessingIndicatorText':
            case 'formSummaryShowRequiredCountColumn':
            case 'formSummaryShowFormNumberColumn':
            case 'businessCard':
            case 'organizationCard':
            case 'richText':
                return componentSettingsConstant.optionGroups.COMPONENT_SPECIFIC_SETTINGS;
        }
    };

};

angular.module('ums.configuration')
    .service('componentSettingsUtil', ComponentSettingsUtil);
